import { z } from 'zod';

export const CogniteFunctionCallType = z.object({
  id: z.number().int().min(1).max(9007199254740991).describe('A server-generated ID for the object.'),
  status: z.enum(['Running', 'Completed', 'Failed', 'Timeout']).describe('Status of the function call.'),
  startTime: z.coerce
    .date()
    .describe(
      'The number of milliseconds since 00:00:00 Thursday, 1 January 1970, Coordinated Universal Time (UTC), minus leap seconds.',
    ),
  endTime: z.coerce
    .date()
    .optional()
    .describe(
      'The number of milliseconds since 00:00:00 Thursday, 1 January 1970, Coordinated Universal Time (UTC), minus leap seconds.',
    ),
  error: z
    .object({
      code: z.string().describe('Error code.'),
      message: z.string().describe('Error message.'),
      details: z.string().optional().describe('Additional error details.'),
    })
    .optional()
    .describe("Error occurring due to user's function code."),
  scheduleId: z.coerce.date().optional().describe('A server-generated ID for the object.'),
  functionId: z.number().int().min(1).max(9007199254740991).describe('A server-generated ID for the object.'),
  scheduledTime: z.coerce
    .date()
    .optional()
    .describe(
      'The number of milliseconds since 00:00:00 Thursday, 1 January 1970, Coordinated Universal Time (UTC), minus leap seconds.',
    ),
});

export type CogniteFunctionCallType = z.infer<typeof CogniteFunctionCallType>;
